module.exports = __webpack_public_path__ + "img/body-bg-m.e3bcd7ce.png";